
import {of as observableOf, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable }       from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SessionService } from '../_services/session.service';
import { User } from '../_models/shared/user';

@Injectable()
export class LoginGuard implements CanActivate {

    constructor(private router: Router, private sessionService: SessionService) { }

    user: User = this.sessionService.getCurrentUser();

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        
        return this.sessionService.getSessionActive().pipe(map(loggedIn => {

            if (loggedIn.Succeed) {
                let urlInicial: string = this.sessionService.obtenerUrlInicial();
                this.router.navigate([urlInicial]);
            }
            
            return !loggedIn.Succeed;

        }),catchError(() => {
            this.router.navigate(['/NoConnection'], { queryParams: { returnUrl: state.url }});
        return observableOf(false);
        }),);
        
    }
}